
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';
import clsx from 'clsx';
import EAIcon from 'components/common/EAIcon';

const EcovadisProgressBullet = ({
  order,
  isActive = false,
  isDone = false,
  label,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.bulletRoot}>
      <div
        className={clsx(
          classes.bullet,
          isActive ? 'bullet-active' : '',
          isDone ? 'bullet-done' : ''
        )}
      >
        {isDone ? <EAIcon icon="done" /> : <>{order}</>}
      </div>
      <div
        className={clsx(classes.bulletLabel, isActive ? 'label-active' : '')}
      >
        {label}
      </div>
    </div>
  );
};

export default EcovadisProgressBullet;